import { render } from "./PanelUsuarioView.vue?vue&type=template&id=05606c5c"
import script from "./PanelUsuarioView.vue?vue&type=script&lang=js"
export * from "./PanelUsuarioView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__